import core from 'Shared/assets/locales/en/core.json'
import partials from 'Shared/assets/locales/en/partials.json'

import constants from './constants.json'
import menuItems from './menuItems.json'
import pages from './pages.json'

export const localeEn = {
	core,
	partials,
	constants,
	menuItems,
	pages
}
